export const Types = {
    GET_ROOT_CAUSE_FAMILIES: "GET_ROOT_CAUSE_FAMILIES",
    SET_ROOT_CAUSE_FAMILIES: "SET_ROOT_CAUSE_FAMILIES",

    GET_ROOT_CAUSE_FAMILY_OPTIONS: "GET_ROOT_CAUSE_FAMILY_OPTIONS",
    SET_ROOT_CAUSE_FAMILY_OPTIONS: "SET_ROOT_CAUSE_FAMILY_OPTIONS",

    GET_OPERATOR_FIVEWS_ONEH_ANALYSIS: "GET_OPERATOR_FIVEWS_ONEH_ANALYSIS",
    SET_OPERATOR_FIVEWS_ONEH_ANALYSIS: "SET_OPERATOR_FIVEWS_ONEH_ANALYSIS",

    GET_EWO_FORMS_LIST: "GET_EWO_FORMS_LIST",
    SET_EWO_FORMS_LIST: "SET_EWO_FORMS_LIST",

    GET_EWO_FORM_DETAIL_BY_ID: "GET_EWO_FORM_DETAIL_BY_ID",
    SET_EWO_FORM_DETAIL_BY_ID: "SET_EWO_FORM_DETAIL_BY_ID",

    POST_EWO_FORM_CREATE_WITH_FILE: "POST_EWO_FORM_CREATE_WITH_FILE",
    SET_EWO_FORM_CREATE_WITH_FILE: "SET_EWO_FORM_CREATE_WITH_FILE",

    POST_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS: "POST_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS",
    SET_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS: "SET_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS",

    GET_CHECK_TASK_HAS_EWO_FORM: "GET_CHECK_TASK_HAS_EWO_FORM",
    SET_CHECK_TASK_HAS_EWO_FORM: "SET_CHECK_TASK_HAS_EWO_FORM",

    GET_OPERATOR_FIELDS_BY_TASK_ID: "GET_OPERATOR_FIELDS_BY_TASK_ID",
    SET_OPERATOR_FIELDS_BY_TASK_ID: "SET_OPERATOR_FIELDS_BY_TASK_ID",

    POST_EWO_FORM_FILE_WITH_EWO_ID: "POST_EWO_FORM_FILE_WITH_EWO_ID",
    SET_EWO_FORM_FILE_WITH_EWO_ID: "SET_EWO_FORM_FILE_WITH_EWO_ID",

    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};

export const getRootCauseFamilies = (payload) => ({
    type: Types.GET_ROOT_CAUSE_FAMILIES,
    payload: payload,
});

export const setRootCauseFamilies = (payload) => ({
    type: Types.SET_ROOT_CAUSE_FAMILIES,
    payload: payload,
});

export const getRootCauseFamilyOptions = (payload) => ({
    type: Types.GET_ROOT_CAUSE_FAMILY_OPTIONS,
    payload: payload,
});

export const setRootCauseFamilyOptions = (payload) => ({
    type: Types.SET_ROOT_CAUSE_FAMILY_OPTIONS,
    payload: payload,
});

export const getOperatorFiveWsOneHAnalysis = (payload) => ({
    type: Types.GET_OPERATOR_FIVEWS_ONEH_ANALYSIS,
    payload: payload,
});

export const setOperatorFiveWsOneHAnalysis = (payload) => ({
    type: Types.SET_OPERATOR_FIVEWS_ONEH_ANALYSIS,
    payload: payload,
});

export const postEwoFormCreateWithFile = (payload) => ({
    type: Types.POST_EWO_FORM_CREATE_WITH_FILE,
    payload,
});

export const setEwoFormCreateWithFile = (payload) => ({
    type: Types.SET_EWO_FORM_CREATE_WITH_FILE,
    payload,
});

export const postEwoFormFileWithEwoId = (payload) => ({
    type: Types.POST_EWO_FORM_FILE_WITH_EWO_ID,
    payload
})

export const setEwoFormFileWithEwoId = (payload) => ({
    type: Types.SET_EWO_FORM_FILE_WITH_EWO_ID,
    payload
})

export const postEwoFormCreateWithOperatorFields = (payload) => ({
    type: Types.POST_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS,
    payload,
});

export const setEwoFormCreateWithOperatorFields = (payload) => ({
    type: Types.SET_EWO_FORM_CREATE_WITH_OPERATOR_FIELDS,
    payload,
});

export const getCheckTaskHasEwoForm = (payload) => ({
    type: Types.GET_CHECK_TASK_HAS_EWO_FORM,
    payload,
});

export const setCheckTaskHasEwoForm = (payload) => ({
    type: Types.SET_CHECK_TASK_HAS_EWO_FORM,
    payload,
});

export const getOperatorFieldsByTaskId = (payload) => ({
    type: Types.GET_OPERATOR_FIELDS_BY_TASK_ID,
    payload,
});

export const setOperatorFieldsByTaskId = (payload) => ({
    type: Types.SET_OPERATOR_FIELDS_BY_TASK_ID,
    payload,
});

export const getEwoFormsList = (payload) => ({
    type: Types.GET_EWO_FORMS_LIST,
    payload: payload,
});

export const setEwoFormsList = (payload) => ({
    type: Types.SET_EWO_FORMS_LIST,
    payload: payload,
});

export const getEwoFormDetailById = (payload) => ({
    type: Types.GET_EWO_FORM_DETAIL_BY_ID,
    payload: payload,
});

export const setEwoFormDetailById = (payload) => ({
    type: Types.SET_EWO_FORM_DETAIL_BY_ID,
    payload: payload,
});



export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});